import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MeetingHistoryDetailsIndex } from '@/pages/history/MeetingHistoryDetailsIndex';

const searchSchema = z.object({
	recordingId: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_app/history/$meetingID')({
	validateSearch: searchSchema,
	component: MeetingHistoryDetailsIndex,
});
